import $ from "jquery";
import React from "react";
import { i18n } from "react-i18n";

import {
	Form,
	FormField,
	Radio,
	RadioGroup,
	Table,
	Alert,
	Button,
	Glyph,
	Loader,
	Row,
	Col,
	Container,
	Card,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter
} from "kepler";

import { parseMessages } from '../../utilityHelper';

const templateData = $("body").data();

let activeDeclaration = templateData.activeDeclaration;
let cancelledDeclaration = templateData.cancelledDeclaration;
let donorInfo=templateData.donorInfo;

const declMsg = parseMessages("giftaid/declaration");

export default class GiftAid8ballDeclaration extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showActive: true,
			showCancelled:false,
			cancelAgreementmodal: false,
			donemodal:false,
			loader:false,
			cancelerror:false
		};
		this.cancelDeclaration = this.cancelDeclaration.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.doneDeclaration = this.doneDeclaration.bind(this);
	}
	componentDidMount() {
		let self = this;
		$("input[name='active_cancelled_radios']:first").prop("checked", true);
		$(document).on('click','.cancelAnchor',function(){
			self.setState({
				cancelAgreementmodal: true,
				showActive: false,
				showCancelled:true,
				donemodal:false,
				cancelerror:false
			});

			$('.cancelLogoBox').attr('style','background-size:contain;background-repeat : no-repeat;background-position : center center;background-image : url(' + $(this).attr("data-charity-logo-url") + ')');
			$('.cancelcharityName').html($(this).attr("data-charity-name"));
			$("#charityAccountNumber").val($(this).attr("data-cancel-id"));
			$("#charityLogoUrl").val($(this).attr("data-charity-logo-url"));
		});
		$("input[name='active_cancelled_radios']").on('click',function(){
			if(this.value == 'cancelled'){
				self.setState({
					showActive: false,
					showCancelled:true,
					cancelAgreementmodal: false,
					donemodal:false
				});
			} else {
				self.setState({
					showActive: true,
					showCancelled:false,
					cancelAgreementmodal: false,
					donemodal:false
				});
			}
		});

	}

	cancelDeclaration(){
		let charityAccountNumber = $('#charityAccountNumber').val();
		let charityName = $('.cancelcharityName').html();
		let charityLogoUrl = $("#charityLogoUrl").val();
		let self = this,
		csrf = $("body").attr("data-csrf"),
			data = {
				preference: false,
				_csrf: csrf,
				charityAccountNumber: charityAccountNumber
			};
		self.setState({
			showActive: true,
			cancelAgreementmodal: false,
			loader:true
		});
		$.post("/givingfund/giftaid/canceldeclaration", data, function(result) {
			if (result.status == 'OK'){
				self.setState({
					showActive: true,
					cancelAgreementmodal: false,
					donemodal:true,
					loader:false
				});
				$('.cancelcharityName').html(charityName);
			} else {
				self.setState({
					showActive: true,
					cancelAgreementmodal: true,
					donemodal:false,
					loader:false,
					cancelerror:true
				});
				$('.cancelLogoBox').attr('style','background-size:contain;background-repeat : no-repeat;background-position : center center;background-image : url(' + charityLogoUrl + ')');
				$('.cancelcharityName').html(charityName);
				$("#charityAccountNumber").val(charityAccountNumber);
				$("#charityLogoUrl").val(charityLogoUrl);
			}
		}).fail(function() {
			self.setState({
				showActive: true,
				cancelAgreementmodal: true,
				donemodal:false,
				loader:false,
				cancelerror:true
			});
			$('.cancelLogoBox').attr('style','background-size:contain;background-repeat : no-repeat;background-position : center center;background-image : url(' + charityLogoUrl + ')');
			$('.cancelcharityName').html(charityName);
			$("#charityAccountNumber").val(charityAccountNumber);
			$("#charityLogoUrl").val(charityLogoUrl);
		});
	}

	toggleModal(){
		let self = this;
		self.setState({
			cancelAgreementmodal: false,
			showActive: true,
			showCancelled:false,
			donemodal:false
		});
	}

	doneDeclaration(){
		let self = this;
		self.setState({
			cancelAgreementmodal: false,
			showActive: true,
			showCancelled:false,
			donemodal:false,
			loader:true
		});
		window.location.href = "/givingfund/giftaid/declaration";
	}
	
	render() {
		var self = this;
		let checkedActive = this.state.showActive ? 'checked' : '';
		let checkedCancelled = this.state.showCancelled ? 'checked' : '';
		let activeresultsList;
		activeresultsList = activeDeclaration.map(function(result, index){
			let cancel_id = index;
			let style = {
		      "backgroundImage":`url(${result.charity_info.confirmation_logo_url})`,
		      "backgroundPosition": "center center",
		      "backgroundRepeat":"no-repeat",
		      "backgroundSize":"contain"
		    }; 
            return <tr key={index}><td><div className="logoBox" style={style}></div>{result.charity_info.name}</td><td>{result.charity_info.confirmation_date}</td><td><span className="activeText">{declMsg.active}</span> <span className="cancelspan"><a href="#" className="cancelAnchor" data-cancel-id={result.charity_info.encrypted_account_number} data-charity-logo-url={result.charity_info.confirmation_logo_url} data-charity-name={result.charity_info.name}>{declMsg.cancel}</a></span></td></tr>						
        });
		let cancelledresultsList;
		cancelledresultsList = cancelledDeclaration.map(function(result, index){
			let style = {
		      "backgroundImage":`url(${result.charity_info.confirmation_logo_url})`,
		      "backgroundPosition": "center center",
		      "backgroundRepeat":"no-repeat",
		      "backgroundSize":"contain"
		    };
            return <tr key={index}><td><div className="logoBox" style={style}></div>{result.charity_info.name}</td><td>{result.charity_info.confirmation_date}</td><td><p className="cancelled">{declMsg.canceled}</p></td></tr>						
        });
		return (
			<Container
				id="giftAidDeclarationReport"
				maxWidth={1024}
				className="container"
			>	
				<Row>
					<Col sm="2/3">
						<h2 className="title" id="gaTitle">{declMsg.declarations}</h2>
						<Form className="radioForm">
							<FormField>
		                        <Radio name="active_cancelled_radios" label={declMsg.showactive} value="active"/>
								<Radio name="active_cancelled_radios" label={declMsg.showcanceled} value="cancelled"/>
							</FormField>
						</Form>
					</Col>
					<Col sm="1/3">
						<div className="Rectangle">
							<div className="leftColumn">
								<p className="title">{declMsg.taxpayerinfo}</p>
								<p><a className="Update" href="/myaccount/settings/">{declMsg.update}</a></p>
							</div>
							<div className="rightColumn">
								<p>{donorInfo.fullName}</p>
								<p>{donorInfo.address1}</p>
								{donorInfo.address2 ? <p>{donorInfo.address2}</p> : ""}
								<p>{donorInfo.city}{donorInfo.state ? ", ": ""} {donorInfo.state ? donorInfo.state : ""}, {donorInfo.zip}</p>
							</div>
						</div>
					</Col>
				</Row>
				{self.state.showActive ? 
					<Table id="charityActiveTable">
						<colgroup>
							<col width="50%" />
							<col width="25%" />
							<col width="25%" />
						</colgroup>
						<thead>
							<tr>
								<th>
									{declMsg.charity}
								</th>
								<th>{declMsg.decldate}</th>
								<th>{declMsg.status}</th>
							</tr>
						</thead>
						<tbody>
							{ activeDeclaration.length > 0 ? 
							activeresultsList : <tr><td colSpan="3">{declMsg.norecordsfound}</td></tr>
							}
						</tbody>
					</Table> : 
					<Table id="charityCancelledTable">
						<colgroup>
							<col width="50%" />
							<col width="25%" />
							<col width="25%" />
						</colgroup>
						<thead>
							<tr>
								<th>
									{declMsg.charity}
								</th>
								<th>{declMsg.decldate}</th>
								<th>{declMsg.status}</th>
							</tr>
						</thead>
						<tbody>
							{ cancelledresultsList.length > 0 ? 
							cancelledresultsList : <tr><td colSpan="3">{declMsg.norecordsfound}</td></tr>
							}
						</tbody>
					</Table> }
				<Modal
					isOpen={this.state.cancelAgreementmodal}
					onCancel={this.toggleModal}
					backdropClosesModal={true}
					showCloseButton={true}
					type="default"
				>
					<ModalHeader />
					<ModalBody>
						<div className="modalbodyWrap">
							{this.state.cancelerror ? <p className="cancelerror"> <Glyph
									icon="icon-critical-small"
									type="danger"
									size="small"
								/><span className="text">{declMsg.cancelerror}</span></p> : ""}
							<div className="cancelLogoBox"></div>
							<h2 className="Cancel-your-Gift-Aid">{declMsg.cancelmodalheader} <span className="cancelcharityName"></span></h2>
							<p className="If-you-cancel-your-d">{declMsg.cancelmodaldesc} <span className="cancelcharityName"></span>.</p>
							<Button id="cancelDecl" onClick={this.cancelDeclaration}>
								{declMsg.cancelmodalcanceldecl}
							</Button>
							<input type="hidden" id="charityAccountNumber"/>
							<input type="hidden" id="charityLogoUrl"/>
						</div>
					</ModalBody>
					<ModalFooter />
				</Modal>
				<Modal
					isOpen={this.state.donemodal}
					onCancel={this.doneDeclaration}
					backdropClosesModal={true}
					showCloseButton={true}
					type="default"
				>
					<ModalHeader />
					<ModalBody>
						<div className="modalbodyWrap">
							<div className="iconHolder">
								<Glyph
									icon="icon-circled-checkmark-large"
									type="success"
									size="large"
								/>
							</div>
							<h2 className="Cancel-your-Gift-Aid">{declMsg.youaregoodtogo}</h2>
							<p className="If-you-cancel-your-d">{declMsg.canceledsuccefullymsg} <span className="cancelcharityName"></span>.</p>
							<Button onClick={this.doneDeclaration}>
								{declMsg.done}
							</Button>
						</div>
					</ModalBody>
					<ModalFooter />
				</Modal>
				<Loader
									show={this.state.loader}
									priority={10}
									type="fixed"
									size="lg"
									opacity={0.5}
									id="declLoader"
								/>
			</Container>

		);
	}
}



// WEBPACK FOOTER //
// ./giftaid/components/declaration.js